import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  CardBody,
  Col,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from "reactstrap";
import { GetLanguageString } from "../helper/Components";
import Draggable from "react-draggable";
import { LoadingSpinner } from "../../constants/const";
import { ApiFinance } from "../funds/ApiFinance";

const labelStyle = {
  fontSize: "12px",
  color: "#6B7280",
  marginBottom: "2px",
  lineHeight: "1.15",
};

const valueStyle = {
  fontSize: "14px",
  fontWeight: 500,
  color: "#1F2937",
  lineHeight: "1.25",
};

const cardBase = {
  borderRadius: "12px",
  border: "1px solid #E5E7EB",
};

const sectionHeader = (color) => ({
  fontSize: "12px",
  fontWeight: 600,
  letterSpacing: "0.04em",
  color,
  textTransform: "uppercase",
  marginBottom: "10px",
});

const animatedBody = {
  animation: "fadeSlideIn 0.25s ease-out",
};

const amountBadge = (bgColor = "#D1FAE5", textColor = "#059669") => ({
  display: "inline-block",
  padding: "2px 8px",
  borderRadius: "12px",
  backgroundColor: bgColor,
  color: textColor,
  fontWeight: 600,
  fontSize: "13px",
});

const FundsOtherIncomeNotificationDetails = ({
  setViewOtherIncomeNotificationDetails,
  notificationId,
}) => {
  const [notificationresponse, setNotificationresponse] = useState({});
  const [loading, setLoading] = useState(false);
  const toggle = () => setViewOtherIncomeNotificationDetails(false);

  const [position, setPosition] = useState({ x: 0, y: 0 });
  const handleDrag = (e, ui) =>
    setPosition((p) => ({ x: p.x + ui.deltaX, y: p.y + ui.deltaY }));

  useEffect(() => {
    if (!notificationId) return;
    setLoading(true);
    ApiFinance()
      .GetOtherIncomeDataForNotification(notificationId)
      .then((res) => {
        if (res.data) setNotificationresponse(res.data || {});
      })
      .finally(() => setLoading(false));
  }, [notificationId]);

  return (
    <>
      <style>
        {`
          @keyframes fadeSlideIn {
            from { opacity: 0; transform: translateY(8px); }
            to { opacity: 1; transform: translateY(0); }
          }
        `}
      </style>

      <Draggable position={position} onDrag={handleDrag} cancel=".no-drag">
        <Modal size="xl" isOpen className="inmodal">
          <ModalHeader className="modal-title">
            <GetLanguageString props="courses_report_details" />
          </ModalHeader>

          {loading ? (
            <ModalBody className="text-center py-4">
              <LoadingSpinner />
            </ModalBody>
          ) : (
            <ModalBody style={animatedBody}>
              <Card
                className="mb-3"
                style={{
                  ...cardBase,
                  background: "#EFF6FF",
                  borderLeft: "5px solid #3B82F6",
                }}
              >
                <CardBody>
                  <div style={sectionHeader("#2563EB")}>
                    {<GetLanguageString props="courses_report_details" />}
                  </div>
                  <Row className="gy-3">
                    <Col md="6">
                      <div style={labelStyle}>
                        {<GetLanguageString props="transactions_memo" />}
                      </div>
                      <div style={valueStyle}>{notificationresponse.memo}</div>
                    </Col>
                    <Col md="6">
                      <div style={labelStyle}>
                        {<GetLanguageString props="funds_receipt_number" />}
                      </div>
                      <div style={valueStyle}>
                        {notificationresponse.recieptNumber}
                      </div>
                    </Col>
                    <Col md="6">
                      <div style={labelStyle}>
                        {<GetLanguageString props="funds_add_fund_amount" />}
                      </div>
                      <div style={amountBadge("#DBEAFE", "#2563EB")}>
                        {new Intl.NumberFormat().format(
                          notificationresponse.amount ||
                            notificationresponse.transferAmount ||
                            0,
                        )}
                      </div>
                    </Col>
                    <Col md="6">
                      <div style={labelStyle}>
                        {<GetLanguageString props="funds_date" />}
                      </div>
                      <div style={valueStyle}>
                        {notificationresponse.date ||
                        notificationresponse.requestDate
                          ? new Date(
                              notificationresponse.date ||
                                notificationresponse.requestDate,
                            ).toLocaleDateString("en-GB")
                          : ""}
                      </div>
                    </Col>
                  </Row>
                </CardBody>
              </Card>{" "}
              {notificationresponse.rafiqAccountTitle || notificationresponse.rafiqAccountNumber || notificationresponse.rafiqBankName ? (
              <Card
                className="mb-3"
                style={{
                  ...cardBase,
                  background: "#EFF6FF",
                  borderLeft: "5px solid #3B82F6",
                }}
              >
                <CardBody>
                  <div style={sectionHeader("#2563EB")}>
                    <GetLanguageString props="transactions_beneficiary_details" />
                  </div>

                  <Row className="gy-3">
                    <Col md="4">
                      <div style={labelStyle}>
                        <GetLanguageString props="transactions_account_title" />
                      </div>
                      <div style={valueStyle}>
                        {notificationresponse.rafiqAccountTitle}
                      </div>
                    </Col>

                    <Col md="4">
                      <div style={labelStyle}>
                        <GetLanguageString props="transactions_account_number" />
                      </div>
                      <div style={valueStyle}>
                        {notificationresponse.rafiqAccountNumber}
                      </div>
                    </Col>

                    <Col md="4">
                      <div style={labelStyle}>
                        <GetLanguageString props="transactions_bank_name" />
                      </div>
                      <div style={valueStyle}>
                        {notificationresponse.rafiqBankName}
                      </div>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
              ) : null}
            </ModalBody>
          )}

          <ModalFooter>
            <Button color="primary" onClick={toggle}>
              <GetLanguageString props="users_role_ok_btn" />
            </Button>
          </ModalFooter>
        </Modal>
      </Draggable>
    </>
  );
};

export default FundsOtherIncomeNotificationDetails;
